<template>
<div class="main-panel">
    <top-navbar></top-navbar>
    <div class="content">
        <div class="card">
        <FlashMessage :position="'right top'"></FlashMessage>

            <div class="card-header">
                <h4 class="title">Edit Role</h4>
            </div>
            <div class="card-body">
                <form @submit.prevent="update">
                    <div class="row">
                        <div class="col-md-5">
                            <label>Role<em style="color:red">*</em></label>
                            <input class="form-control" v-model.trim="$v.roledata.role.$model" type="text" label="Role" placeholder="Enter role" />
                            <div class="error" v-if="submitted && !$v.roledata.role.required">Please enter role</div>

                        </div>
                        <!-- </div> -->

                        <!-- <div class="row"> -->
                        <div class="col-md-5">
                            <label>Status<em style="color:red">*</em></label>
                            <select class="form-control" v-model.trim="$v.roledata.status.$model">
                                <option selected disabled>Select status</option>
                                <option value="1">Active</option>
                                <option value="0">InActive</option>
                            </select>
                            <div class="error" v-if="submitted && !$v.roledata.status.required">Please select status</div>

                        </div>

                    </div>

                    <div class="text">
                        <button type="submit" class="btn btn-secondary dashboard">Update</button>&nbsp;
                        <router-link to="/admin/dashboard/role"><button type="button" class="btn btn-secondary dashboard">Cancel</button></router-link>

                    </div>

                </form>
            </div>
        </div>

    </div>
    <content-footer></content-footer>
</div>
</template>

<script>
import TopNavbar from "../../Dashboard/Layout/TopNavbar.vue";
import ContentFooter from "../../Dashboard/Layout/ContentFooter.vue";
import ValidationError from "src/components/UIComponents/ValidationError.vue";
import {
    required,
    minLength,
    maxLength,
    between,
} from "vuelidate/lib/validators";
export default {
    name: 'editRole',
    components: {
        TopNavbar,
        ContentFooter,
    },

    data() {
        return {
            submitted: false,

            roledata: {
                role: '',
                status: '',
            }
        }
    },

    validations: {
        roledata: {
            role: {
                required,
            },
            status: {
                required,
            },
        }
    },

    methods: {
        update() {
            this.submitted = true;
            this.$v.$touch()
            if (this.$v.$invalid) {
                return;
            } else {
                this.axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/role/update/` + this.$route.params.id, this.roledata)
                    .then(({
                        data
                    }) => {
                        this.flashMessage.success({
                            message: 'Role Updated Successfully '
                        });
                        this.$router.push('/admin/dashboard/role');
                    })
                // .catch((error) => {
                //     console.log(error);
                // });
            }
        }
    },

    async mounted() {
        const roledata = await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/role/edit/` + this.$route.params.id);
        this.roledata = roledata.data.data;
    },

};
</script>

<style lang="scss">
</style>
